// @ts-check
import React from 'react';
import { RebrandNoticeModal } from './RebrandNoticeModal';

/** @typedef {{
  currentAgent: {
    aristamdRebrandNoticeAcknowledged: boolean;
  };
}} RebrandNoticeProps */

/** @type { React.FC<RebrandNoticeProps> } */
export const RebrandNotice = (props) => {
  const { currentAgent } = props;
  const [isOpen, setIsOpen] = React.useState(
    !currentAgent.aristamdRebrandNoticeAcknowledged
  );

  return (
    <RebrandNoticeModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
  );
};
